module.exports = __webpack_public_path__ + "static/media/bgMaquinaTejHomePC.2da54aa5.jpg";